module.exports = __webpack_public_path__ + "static/media/Music-Library-API.9072187d.png";